export function detectMobile() { 
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
    ){
        return true;
    } else {
        return false;
    }
}
export function extensionOpen() {
    let _inDom = document.getElementById("__klue_frame__") != null ? true : false;
    return _inDom;
}


Math.easeInOutQuad = function(t, b, c, d) {
    //t = current time
    //b = start value
    //c = change in value
    //d = duration
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
};

export function scrollTo(element, to, duration) {
    let start = element.scrollLeft,
        change = to - start,
        currentTime = 0,
        increment = 20;
    
    console.log('_helpers.js : scrollTo(element, to, duration)');
    
    let animateScroll = function() {        
        currentTime += increment;
        let val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollLeft = val;
        
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}